import { render, staticRenderFns } from "./msTrGroup.vue?vue&type=template&id=6696d456&scoped=true"
import script from "./msTrGroup.vue?vue&type=script&lang=js"
export * from "./msTrGroup.vue?vue&type=script&lang=js"
import style0 from "./msTrGroup.vue?vue&type=style&index=0&id=6696d456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6696d456",
  null
  
)

export default component.exports